/* global axios */
import ApiClient from '../ApiClient';

class AssistantDocuments extends ApiClient {
  constructor() {
    super('assistant/documents', { accountScoped: true });
  }

  get({ page = 1, searchKey, assistantId, knowledgeBaseId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search_key: searchKey,
        assistant_id: assistantId,
        knowledge_base_id: knowledgeBaseId,
      },
    });
  }

  create(data = {}) {
    return axios.post(this.url, { document: data });
  }

  // Р9.3: редактирование документа (name/content) с переиндексацией на бэке.
  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { document: data });
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }

  // Multipart upload (Р4/Р9.3): FormData with knowledge_base_id (или легаси
  // assistant_id), один file или несколько files[].
  upload(formData) {
    return axios.post(`${this.url}/upload`, formData);
  }
}

export default new AssistantDocuments();
